(function () {
  function initCountdown(el) {
    var targetStr = el.getAttribute('data-target');
    var expiredText = el.getAttribute('data-expired-text') || 'Promoção encerrada';
    var redirectUrl = el.getAttribute('data-expired-redirect');
    var target = new Date(targetStr).getTime();

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');

    if (isNaN(target)) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date().getTime();
      var diff = target - now;

      if (diff <= 0) {
        clearInterval(timer);
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          el.innerHTML = '<p class="countdown-expired-text">' + expiredText + '</p>';
        }
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      var daysDividerEl = el.querySelector('[data-days-divider]');
      if (daysEl) {
        var dayUnit = daysEl.closest('.countdown-unit');
        if (days > 0) {
          daysEl.textContent = pad(days);
          if (dayUnit) dayUnit.style.display = '';
          if (daysDividerEl) daysDividerEl.style.display = '';
        } else {
          if (dayUnit) dayUnit.style.display = 'none';
          if (daysDividerEl) daysDividerEl.style.display = 'none';
        }
      }
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function init() {
    var timers = document.querySelectorAll('[data-countdown]');
    timers.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();